import(/* webpackMode: "eager" */ "/builds/entpay/mobile-apps/AWE/cotv-xfinity/app/global-error.tsx");
